import * as model from "./model";
import defaultPersonRecord from "~/admin/setup/person/data/default-record";

const userDefaultRecord = () => ({
    ...defaultPersonRecord(),
    [model.PROPS_ADD_USER_ACCOUNT_VISIBLE]: true,
});

export default userDefaultRecord;
